import { TermsAndConditions } from "../components/legal/TermsAndConditions";
import { Link } from "react-router-dom";
import {ArrowLeft} from 'lucide-react';

export default function TermsPage() {
  return (
    <>
      <div className="fixed top-6 left-6 z-50">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white px-4 py-2 rounded-lg hover:bg-white/20 transition-all duration-300"
        >
          <ArrowLeft className="w-5 h-5" />
          Volver al Inicio
        </Link>
      </div>
      <TermsAndConditions />
    </>
  );
}
